module.exports = __webpack_public_path__ + "img/bm-osm.a45ebc7c.png";